export const handleNoteClick = (noteId, isSwiped, setIsSwiped, navigate) => {
  if (isSwiped) {
    setIsSwiped(false);
    return;
  }
  if (noteId) {
    navigate(`/get-expenses/${noteId}`);
  } else {
    console.error('Note invalide : ID manquant');
  }
}; 